import { tooltipOptions } from './Tooltip.options'
import { TooltipParts } from './Tooltip.parts'

export const Tooltip = {
  options: tooltipOptions,
  isActive: TooltipParts.isActive,
}
